import React, { useState } from 'react';
import { WholesaleInfoPopup } from './WholesaleInfoPopup';
export function EmailPopup({
  onSubmit,
  isOpen,
  isLoadingFromId = false,
  processEmail
}) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showWholesaleInfo, setShowWholesaleInfo] = useState(false);
  const handleSubmit = async e => {
    e.preventDefault();
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    setLoading(true);
    try {
      const priceType = await processEmail(email);
      onSubmit(email, priceType);
    } catch (error) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  if (!isOpen) return null;
  const isDisabled = loading || isLoadingFromId;
  return <>
      <WholesaleInfoPopup isOpen={showWholesaleInfo} onClose={() => setShowWholesaleInfo(false)} data-id="element-64" />
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-65">
        <div className="bg-white rounded-lg p-8 max-w-md w-full shadow-2xl relative" data-id="element-66">
          {isDisabled && <div className="absolute inset-0 bg-white bg-opacity-90 rounded-lg flex items-center justify-center z-10" data-id="element-67">
              <div className="flex flex-col items-center" data-id="element-68">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-69"></div>
                <p className="mt-4 text-gray-700 font-medium" data-id="element-70">
                  {isLoadingFromId ? 'Loading...' : 'Processing...'}
                </p>
              </div>
            </div>}
          <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-71">Welcome!</h2>
          <p className="mb-6 text-gray-700" data-id="element-72">
            Please enter your email address to continue to our quote builder.
          </p>
          <form onSubmit={handleSubmit} data-id="element-73">
            <div className="mb-4" data-id="element-74">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-75">
                Email Address <span className="text-red-500" data-id="element-76">*</span>
              </label>
              <input type="email" id="email" value={email} onChange={e => {
              setEmail(e.target.value);
              setError('');
            }} className="border rounded-md px-3 py-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="your@email.com" required disabled={isDisabled} data-id="element-77" />
              {error && <p className="text-red-500 text-sm mt-1" data-id="element-78">{error}</p>}
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white px-4 py-2 rounded-md font-bold hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed mb-3" disabled={isDisabled} data-id="element-79">
              {loading ? 'Loading...' : 'Continue to Quote Builder'}
            </button>
            <button type="button" onClick={() => setShowWholesaleInfo(true)} className="w-full bg-amber-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-amber-600 transition-colors" disabled={isDisabled} data-id="element-80">
              Do you have a Wholesale Account?
            </button>
            <p className="text-xs text-gray-500 mt-4 text-center" data-id="element-81">
              We'll use your email to save your quote and contact you with more
              information.
            </p>
          </form>
        </div>
      </div>
    </>;
}